export { StockPage as default } from '@/components/enpages/Ir/Stock'
